enum PatientCheckoutViewCartEntryPoint {
  TOP_NAV = "TopNav",
  MINI_CART = "MiniCart",
  TREATMENT_PLAN_VIEW_CART_TILE = "TreatmentPlan_ViewCartTile",
}

enum PatientCheckoutViewCartViewContext {
  GUIDED_NO_NAV = "guided_no_nav",
  NORMAL_WITH_NAV = "normal_with_nav",
}

enum PatientCheckoutStartEntryPoint {
  CART_PAGE = "CartPage",
  MINI_CART = "MiniCart",
  PLAN_PAGE = "PlanPage",
}

interface TreatmentPlanViewCartAnalytics {
  has_labs: boolean;
  has_lab_journey: boolean;
  treatment_plan_ids: string[];
}

interface TreatmentPlanAddToCartAnalytics {
  treatment_plan_id?: string;
  has_labs: boolean;
  has_lab_journey: boolean;
}

enum PatientProductEntryPoint {
  CATALOG_PAGE_CATALOG_PRODUCT = "CatalogPage_CatalogProduct",
  PRODUCT_PAGE_DETAIL_PRODUCT = "ProductPage_DetailProduct",
  CATALOG_PAGE_NEW_ON_FULLSCRIPT_PRODUCT = "CatalogPage_NewOnFullScriptProduct",
  ORDER_PAGE_ORDER_ITEM_PRODUCT = "OrderPage_OrderItemProduct",
  ORDER_PAGE_ORDER_ITEMS_PRODUCT = "OrderPage_OrderItemsProduct",
  CATALOG_PAGE_PREVIOUSLY_ORDERED_PRODUCT = "CatalogPage_PreviouslyOrderedProduct",
  CATALOG_PAGE_RECENTLY_VIEWED_PRODUCT = "CatalogPage_RecentlyViewedProduct",
  PRODUCT_DETAIL_PAGE_RECENTLY_VIEWED_PRODUCT = "ProductDetailPage_RecentlyViewedProduct",
  TREATMENT_PLAN_RECOMMENDATION_PRODUCT = "TreatmentPlan_RecommendationProduct",
  TREATMENT_PLAN_PRODUCT_SUBSTITUTE = "TreatmentPlan_ProductSubstitute",
  TREATMENT_PLAN_SIMILAR_PRODUCT_FROM_PLAN = "TreatmentPlan_SimilarProductFromPlan",
  TREATMENT_PLAN_ALTERNATIVE_PRODUCT = "TreatmentPlan_AlternativeProduct",
  TREATMENT_PLAN_RECOMMENDATION_LAB_TEST = "TreatmentPlan_RecommendationLabTest",
  TREATMENT_PLAN_RECOMMENDATION_JOURNEY = "TreatmentPlan_RecommendationJourney",
  PROTOCOL_RECOMMENDATION_PRODUCT = "Protocol_RecommendationProduct",
  PRODUCT_PAGE_SIMILAR_PRODUCT = "ProductPage_SimilarProduct",
  CATALOG_PAGE_SPOTLIGHT_PRODUCT = "CatalogPage_SpotlightProduct",
  CATALOG_PAGE_PILLPACK_PRODUCT = "CatalogPage_PillPackProductBanner",
  CATALOG_PAGE_DAILYPACK_SHOWCASE = "CatalogPage_DailyPackShowcase",
  UNAVAILABLE_MODAL_UNAVAILABLE_PRODUCT = "UnavailableModal_UnavailableProduct",
  UNAVAILABLE_MODAL_SIMILAR_PRODUCT = "UnavailableModal_SimilarProduct",
  ORDER_PAGE_SWAPPED_PRODUCT = "OrderPage_SwappedProduct",
  ORDER_PAGE_POPULAR_PRODUCT = "OrderPage_PopularProduct",
  AUTOSHIP_PAGE_PREVIOUSLY_ORDERED_PRODUCT = "AutoshipPage_PreviouslyOrderedProduct",
  AUTOSHIP_PAGE_AUTOSHIPPED_PRODUCT = "AutoshipPage_AutoShippedProduct",
  PRODUCT_PAGE_SWAPPED_PRODUCT = "ProductPage_SwappedProduct",
  RECOMMENDATION_PAGE_SWAPPED_PRODUCT = "RecommendationPage_SwappedProduct",
  SHOPPING_CART_SIDEBAR_PRODUCT = "ShoppingCartSidebar_Product",
  SUPPLEMENT_PLAN_EDIT_DETAIL_PRODUCT = "SupplementPlan_Edit_DetailProduct",
  SUPPLEMENT_PLAN_ADD_DETAIL_PRODUCT = "SupplementPlan_Add_DetailProduct",
  MEGA_MENU = "MegaMenu",
  CATALOG_PAGE = "CatalogPage",
  CART_PAGE = "CartPage",
  CATALOG_PAGE_FAVORITES = "CatalogPage_Favorites",
  CATALOG_PAGE_COLLECTIONS = "CatalogPage_Collections",
  COLLECTION_PAGE = "CollectionPage",
  PROTOCOL_PAGE = "ProtocolPage",
  CATEGORY_PAGE_POPULAR_PRODUCTS_CARD = "CategoryPage_PopularProducts_ProductCard",
  BASKET_FILLERS_PAGE_PRODUCT = "BasketFillersPage_Product",
  PATIENT_CATALOG_TYPE_AHEAD = "Catalog_Typeahead",
  PATIENT_TYPEAHEAD_V3_FEATURED = "Patient_Typeahead_v3_Featured",
  PATIENT_TYPEAHEAD_V3_BANNER = "Patient_Typeahead_v3_Banner",
  PATIENT_TYPEAHEAD_V3_TRENDING = "Patient_Typeahead_v3_Trending",
  PATIENT_TYPEAHEAD_V3_SUGGESTED_SEARCHES = "Patient_Typeahead_v3_SuggestedSearches",
  PATIENT_TYPEAHEAD_V3_SUGGESTED_PRODUCTS = "Patient_Typeahead_v3_SuggestedProducts",
  MY_HEALTH_OVERVIEW_ROUTINE = "MyHealthOverview_Routine",
  SAVE_FOR_LATER_PAGE = "SaveForLaterPage_Product",
  QUICK_VIEW = "QuickView",
  QUICK_VIEW_VIEW_DETAILS = "QuickView_ViewDetails",
}

enum PatientAppViewEntryPoint {
  SMART_BANNER = "SmartBanner",
  NAVIGATION_SIDE_BAR = "NavigationSideBar",
  ORDER_CONFIRMATION_MODAL = "OrderConfirmationModal",
  PATIENT_PAGE_FOOTER = "PatientPageFooter",
  PATIENT_CONTINUE_WITH_APP_DRAWER = "PatientContinueWithAppDrawer",
  PATIENT_PAGE_ASIDE = "PatientPageAside",
  PATIENT_ORDER_DETAILS = "PatientOrderDetails",
  PATIENT_POST_ORDER_MODAL = "PatientPostOrderModal",
  PATIENT_AUTOSHIP_SCREEN = "PatientAutoshipScreen",
  PATIENT_ACCOUNT_DETAILS_SCREEN = "PatientAccountDetailsScreen",
  PATIENT_CHECKOUT_SHIPPING_SCREEN = "PatientCheckoutShippingScreen",
  PATIENT_CHECKOUT_PAYMENT_SCREEN = "PatientCheckoutPaymentScreen",
  PATIENT_ORDER_REFUND_MODAL = "PatientOrderRefundModal",
  FIRST_ORDER_CONFIRMATION = "FirstOrderConfirmation",
  TREATMENT_PLAN_SIDEBAR = "TreatmentPlanSidebar",
  LIFESTYLE_RECOMMENDATIONS_FOOTER = "LifestyleRecommendationsFooter",
  GET_THE_APP_PAGE_DOWNLOAD_BUTTON = "GetTheAppPageDownloadButton",
  GET_THE_APP_PAGE_STORE_BADGE = "GetTheAppPageStoreBadge",
}

enum PatientSetPasswordEntryPoint {
  ORDER_CONFIRMATION_MODAL = "OrderConfirmationModal",
  PATIENT_MY_ACCOUNT_PAGE = "PatientMyAccountPage",
  ACCOUNT_CLAIM_PAGE = "AccountClaimPage",
}

enum PatientTermsEntryPoint {
  TERMS_PRIVACY_MODAL = "TermsPrivacyModal",
  ACCOUNT_CLAIM_PAGE = "AccountClaimPage",
}

enum PatientOrderEntryPoint {
  ORDERS_PAGE_LINE_ITEM = "OrdersPage_LineItem",
  ORDER_PAGE_SHIPMENTS = "OrderPage_Shipments",
  POST_ORDER = "postOrder",
  ORDERS_TAB = "OrdersTab",
  ORDERS_TABS_SELECTOR = "OrdersTabs_Selector",
  REFILL_PREVIOUS_ORDER = "OrdersTab_RefillPreviousOrder",
}

enum PatientSelectEntryPoint {
  TREATMENT_PLAN_EDIT = "TreatmentPlanEdit_Prescription_SelectPatient",
  TREATMENT_PLAN_PATIENT_SELECT_DROPDOWN = "TreatmentPlan_PatientSelectDropdown",
  PLAN_REVIEW_PATIENT_SELECT_DROPDOWN = "PlanReview_PatientSelectDropdown",
  PATIENT_SELECT_MODAL = "PatientSelectModal",
  PLAN_TOOLBAR_SELECT_DROPDOWN = "PlanToolbar_PatientSelectDropdown",
  CARE_CENTER_PATIENT_PANEL = "CareCenter_PatientPanel_ViewPatient",
  INDIVIDUAL_PLANS_PAGE = "IndividualPlansPage_ViewPatient",
  PATIENTS_LIST_PAGE = "PatientsListPage_ViewPatient",
  PATIENTS_LIST_PAGE_BUTTON = "PatientsListPage_Button_ViewPatient",
  PLAN_REVIEW_VIEW_PATIENT_HISTORY = "PlanReview_ViewPatientHistory_ViewPatient",
  ACTIVE_SWAP_PAGE_INDIVIDUAL = "ActiveSwapPage_Individual_ViewPatient",
}

enum PatientLabsEntryPoint {
  TREATMENT_PLAN_LABS_VIEW = "TreatmentPlan_LabsView",
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  LABS_TAB_UPCOMING_BANNER = "LabsTab_UpcomingBanner",
}

enum PatientCurrentSupplementsEntryPoint {
  MY_HEALTH = "MyHealth",
  ACTIONS_MODAL = "SupplementPlan_ActionsModal",
}

enum PatientProductSwapEntryPoint {
  TREATMENT_PLAN_RECOMMENDATION_PRODUCT = "TreatmentPlan_RecommendationProduct",
}

enum PatientMegaMenuEntryPoint {
  CATALOG_INTERCEPT = "CatalogIntercept",
  CATALOG_PAGE = "CatalogPage",
  MEGA_MENU = "MegaMenu",
  ALL_BRANDS_PAGE = "AllBrandsPage",
}

enum PatientViewMPPEntryPoint {
  CATALOG_INTERCEPT = "CatalogIntercept",
  CATALOG_PAGE = "CatalogPage",
  MY_HEALTH_PAGE = "MyHealth",
  PROTOCOLS_LIST_PAGE = "ProtocolsListPage",
  STORE_LANDING_PAGE = "StoreLandingPage",
}

enum PatientSignupEntryPoint {
  UN_AUTH_CART = "UnAuthCart",
  NO_INVITE_SIGNUP = "NoInviteSignup",
  ORPHANED_ACCOUNT_LOGIN = "OrphanedAccountLogin",
}

enum PatientSpotlightClickToNavigateEntryPoint {
  HOME_PAGE = "Homepage",
  PRODUCTS_PAGE = "ProductsPage",
  TYPEAHEAD = "Typeahead",
  MEGA_MENU = "MegaMenu",
  CATALOG_PAGE = "CatalogPage",
  PRODUCT_CARD_BANNER = "ProductCardBanner",
}

enum PatientPromoCodeEntryPoint {
  CART_PAGE = "CartPage",
  CHECKOUT_PAGE = "CheckoutPage",
}

enum PatientLifestyleRecommendationEntryPoint {
  RECOMMENDATIONS_PAGE = "RecommendationsPage",
  STOREFRONT_PROTOCOL_PAGE = "StorefrontProtocolPage",
}

enum PatientTreatmentPlanEntryPoint {
  WRONG_STORE_MODAL = "TreatmentPlan_WrongStoreModal",
  GENERAL_PAGE_ERROR = "TreatmentPlan_GeneralPageError",
}

enum PatientClickBookingLinkEntryPoint {
  TREATMENT_PLAN_PAGE = "TreatmentPlanPage",
  PLANS_LIST_PAGE = "PlansListPage",
  MY_HEALTH_OVERVIEW = "MyHealthOverview",
}

enum PatientJourneyReferralEntryPoint {
  JOURNEY_WELLNESS_PLAN = "JourneyWellnessPlan",
}

enum PatientAutoshipModifyEntryPoint {
  DEFLECTION_STEP = "DeflectionStep",
}

enum PatientAutoRefillEntryPoint {
  PREVIOUSLY_ORDERED_AUTOSHIP_PAGE = "PreviouslyOrderedAutoshipPage",
  AUTOSHIP_SCHEDULE_MULTIPLE_PAGE = "AutoshipScheduleMultiplePage",
  ORDER_HISTORY_PAGE = "OrderHistoryPage",
  ORDER_DETAILS_PAGE = "OrderDetailsPage",
  WELLEVATE_ORDER_HISTORY_PAGE = "WellevateOrderHistoryPage",
  WELLEVATE_ORDER_DETAILS_PAGE = "WellevateOrderDetailsPage",
  PREVIOUSLY_ORDERED_CATALOG_PAGE = "PreviouslyOrderedCatalogPage",
  CHECKOUT_PAGE = "CheckoutPage",
  ORDERS_TAB_REFILL_PREVIOUS_ORDER = "OrdersTab_RefillPreviousOrder",
  AUTOSHIP_SCHEDULE = "AutoshipSchedule",
  PRODUCT_DETAILS = "ProductDetails",
  HOME = "Home",
  SUPPLEMENT_PLAN_LANDING = "SupplementPlanLanding",
  AUTO_REFILL_RECOMMENDATIONS_CAROUSEL = "AutoRefillRecommendationsCarousel",
  AUTO_REFILL_RECOMMENDATIONS_MODAL = "AutoRefillRecommendationsModal",
}

enum PatientCheckoutBackToCartStep {
  SHIPPING = "shipping",
  DELIVERY = "delivery",
  PAYMENT = "payment",
  BASKET_FILLERS = "basket_fillers",
}

enum PatientOverviewEntryPoint {
  ROUTINE = "overview_routine",
  LABS = "overview_labs",
  AUTO_REFILL = "overview_auto_refill",
}

enum PatientFollowUpIntakeSurveyEntryPoint {
  PRE_PURCHASE = "pre-purchase",
  POST_PURCHASE = "post-purchase",
  PRAC_PAY = "prac-pay",
}

enum PatientBuyNowAction {
  ADD_TO_CART = "add_to_cart",
  BUY_NOW = "buy_now",
}

enum PatientNavEntryPoint {
  TOP_NAV = "TopNav",
  MOBILE_HEADER = "MobileHeader",
}

enum PatientNavElementName {
  LOGO = "Logo",
}

type PatientEntryPoint =
  | PatientCheckoutViewCartEntryPoint
  | PatientCheckoutStartEntryPoint
  | PatientProductEntryPoint
  | PatientAppViewEntryPoint
  | PatientOrderEntryPoint
  | PatientSetPasswordEntryPoint
  | PatientTermsEntryPoint
  | PatientSelectEntryPoint
  | PatientLabsEntryPoint
  | PatientCurrentSupplementsEntryPoint
  | PatientProductSwapEntryPoint
  | PatientMegaMenuEntryPoint
  | PatientViewMPPEntryPoint
  | PatientSpotlightClickToNavigateEntryPoint
  | PatientPromoCodeEntryPoint
  | PatientLifestyleRecommendationEntryPoint
  | PatientTreatmentPlanEntryPoint
  | PatientClickBookingLinkEntryPoint
  | PatientJourneyReferralEntryPoint
  | PatientAutoshipModifyEntryPoint
  | PatientAutoRefillEntryPoint
  | PatientOverviewEntryPoint
  | PatientFollowUpIntakeSurveyEntryPoint
  | PatientNavEntryPoint;

export type { PatientEntryPoint, TreatmentPlanViewCartAnalytics, TreatmentPlanAddToCartAnalytics };

export {
  PatientCheckoutViewCartEntryPoint,
  PatientCheckoutViewCartViewContext,
  PatientCheckoutStartEntryPoint,
  PatientProductEntryPoint,
  PatientAppViewEntryPoint,
  PatientSetPasswordEntryPoint,
  PatientTermsEntryPoint,
  PatientOrderEntryPoint,
  PatientSelectEntryPoint,
  PatientLabsEntryPoint,
  PatientCurrentSupplementsEntryPoint,
  PatientProductSwapEntryPoint,
  PatientMegaMenuEntryPoint,
  PatientViewMPPEntryPoint,
  PatientSignupEntryPoint,
  PatientSpotlightClickToNavigateEntryPoint,
  PatientPromoCodeEntryPoint,
  PatientLifestyleRecommendationEntryPoint,
  PatientTreatmentPlanEntryPoint,
  PatientJourneyReferralEntryPoint,
  PatientAutoshipModifyEntryPoint,
  PatientAutoRefillEntryPoint,
  PatientCheckoutBackToCartStep,
  PatientOverviewEntryPoint,
  PatientFollowUpIntakeSurveyEntryPoint,
  PatientBuyNowAction,
  PatientNavEntryPoint,
  PatientNavElementName,
  PatientClickBookingLinkEntryPoint,
};
